export const celIsraeli = {
  regex: /^0(?:[234689]|5[0-689]|7[246789])(?![01])(\d{7})$/,
  massge: "CEL_ISRAELI_ERROR",
};

export const path = {
  regex: /^(?=[a-zA-Z0-9._]{4,20}$)(?!.*[_.]{2})[^_.].*[^_.]$/,
  massge: "PATH_ERROR",
};
export const onlyNumber = {
  regex: /^-?[0-9]*$/,
  massge: "ONLY_NUMBER_ERROR",
};

export const latLonl = {
  regex: /^(-?\d+(\.\d+)?),\s*(-?\d+(\.\d+)?)$/,
  massge: "LAT_LONL_ERROR",
};

export const passWord = {
  regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
  massge: "PASSWORD_ERROR",
};

export const url = {
  regex:
    /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
  massge: "URL_ERROR",
};

export const email = {
  regex:
    /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
  massge: "EMAIL_ERROR",
};
